<template>
  <div class="station">
    <i class="fas fa-angle-right"></i>
    <div class="name">{{ item.displayName }}</div>
  </div>
</template>

<script>
export default {
  props: {
    item: { required: true },
    searchText: { required: true },
  },
};
</script>
